<div class="form-content-item">
  <form [formGroup]="form" (keydown.enter)="$event.stopPropagation()">
    <div class="form-header-item">
      <action-bar (onSave)="clickSave()"></action-bar>
    </div>
    <div>
      <div>
        <h3 class="title-margin-top">{{ 'account_section_user' | translate }}</h3>
        <mat-card>
          <div class="row">
            <div class="col-3">
              <mat-form-field>
                <mat-label color="accent">{{ 'account_field_lastname' | translate }}</mat-label>
                <input matInput formControlName="userName" minlength="2" required />
                <mat-error *ngIf="formCrls.userName.invalid">{{ 'account_error_lastname_required' | translate }}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-3">
              <mat-form-field>
                <mat-label>{{ 'account_field_firstname' | translate }}</mat-label>
                <input matInput formControlName="userFirstName" required />
                <mat-error *ngIf="formCrls.userFirstName.invalid">{{ 'account_error_firstname_required' | translate }}</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <mat-form-field>
                <mat-label>{{ 'account_field_email' | translate }}</mat-label>
                <input matInput formControlName="email" maxlength="256" required />
                <mat-error *ngIf="formCrls.email.invalid">{{ 'account_error_email_required' | translate }}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-3">
              <mat-form-field>
                <mat-label color="accent">{{ 'account_field_login' | translate }}</mat-label>
                <input matInput formControlName="userLogin" />
              </mat-form-field>
            </div>
            <div class="col-3">
              <mat-form-field>
                <mat-label color="accent">{{ 'account_field_status' | translate }}</mat-label>
                <input matInput formControlName="status" />
              </mat-form-field>
            </div>
          </div>
        </mat-card>
      </div>

      <div>
        <div class="title-margin-top edit-password">
          <h3>{{ 'account_section_change_password' | translate }}</h3>
          <div class="btn-add">
            <button mat-mini-fab (click)="addValidators(formCrls, isChangePassword)">
              <mat-icon> {{ isChangePassword ? 'expand_more' : 'expand_less' }}</mat-icon>
            </button>
          </div>
        </div>
        <mat-card *ngIf="isChangePassword">
          <div class="row">
            <div class="col-3">
              <mat-form-field>
                <mat-label>{{ 'account_field_current_password' | translate }}</mat-label>
                <input type="password" matInput formControlName="oldPassword" />
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <mat-form-field>
                <mat-label>{{ 'account_field_new_password' | translate }}</mat-label>
                <input type="password" matInput formControlName="password" />
              </mat-form-field>
              <mat-error *ngIf="formCrls.password.errors?.minlength">{{ 'account_error_password_min_length' | translate }}</mat-error>
              <mat-error *ngIf="formCrls.password.errors?.pattern">
                {{ USER_ACCOUNT_CONSTANTS.PasswordPatternErrorMessage }}
              </mat-error>
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <mat-form-field>
                <mat-label>{{ 'account_field_confirm_password' | translate }}</mat-label>
                <input type="password" matInput formControlName="confirmPassword" />
              </mat-form-field>
              <mat-error *ngIf="formCrls.confirmPassword.errors">{{ 'account_error_password_mismatch' | translate }}</mat-error>
              <mat-error *ngIf="formCrls.confirmPassword.errors?.minlength">{{ 'account_error_password_min_length' | translate }}</mat-error>
              <mat-error *ngIf="formCrls.confirmPassword.errors?.pattern">
                {{ USER_ACCOUNT_CONSTANTS.PasswordPatternErrorMessage }}
              </mat-error>
            </div>
          </div>
        </mat-card>
      </div>

      <app-personal-access-token></app-personal-access-token>
    </div>
  </form>
</div>
